export default __webpack_public_path__ + "static/media/logoBlanc.92ebfdf2.png";